import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { ITheoryComponent } from '../ITheoryComponent';

interface IHtmlComponentData {
  htmlData: string;
}

export const HtmlComponent = observer(({ data }: ITheoryComponent<IHtmlComponentData>) => {
  return (
    <Box sx={{ marginBottom: '16px', width: '100%', fontSize: '20px', lineHeight: 1.6 }}>
      <div dangerouslySetInnerHTML={{ __html: data.htmlData }}></div>
    </Box>
  );
});
